import React  from 'react';

import Modal from "../global/Modal";
import Button from "../global/Button";
import InputField from "../global/InputField";
import CheckBox from "../global/CheckBox";


export default class ConfirmAction extends React.Component {

    state = { opened: false, openModal: null, closeModal: null };

    componentDidMount() {
        window.openConfirmActionModal = this.openModal;
    }

    getOpen = (open) => {
        this.setState({ openModal: open });
    };

    openModal = (options, close_cb = function() {}) => {
        let state = { action_text: options.action_text, confirm_cb: options.confirm_cb, opened: true, undismissible: options.undismissible, close_cb: close_cb };

        this.setState(state, this.state.openModal);
    };

    getClose = (close) => {
        this.setState({ closeModal: close });
    };

    afterOpen = () => {
        //$(".lean-overlay").last().addClass("alert-popup-overlay");
    };

    afterClose = () => {
        this.setState({opened: false}, this.state.close_cb);
    };

    onValueChange = (value) => {
        this.setState({value: value});
    };

    onSubmit = () => {
        this.state.closeModal();
        this.state.confirm_cb();
    };

    render() {
        let disabled = false, content;
        if(this.state.opened){
            content = <div id="confirm-action-content" className="reglisse">
                <h3 style={{margin: 0}}>{"Confirmer action"}</h3>
                <div style={{marginTop: '50px'}}>
                    {this.state.action_text}
                </div>
                <div className="modal-footer">
                    <Button text={'Confirmer'} className='rm theme-btn' onClick={this.onSubmit} disabled={disabled} style={{fontSize: "20px", borderRadius: "18px"}} />
                    <Button text={"Annuler"} color="red" onClick={this.state.closeModal} style={{fontSize: "20px", borderRadius: "18px"}}/>
                </div>
            </div>;
        }
        return (
            <Modal id="confirm-action-modal"
                   content={content}
                   getOpen={this.getOpen}
                   getClose={this.getClose}
                   afterOpen={this.afterOpen}
                   afterClose={this.afterClose}
                   undismissible={this.state.undismissible}
            />
        )
    }
};
